import React, { useMemo } from 'react';

import { useContentfulNavBar } from 'src/components/NavBar/UseContentfulNavBar';
import { useNavBarContext } from 'src/components/NavBarContext/NavBarContext';
import { useSidebar } from 'src/components/SidebarContext/SidebarContext';
import { getField } from '../../utils/EntryUtil';
import { NavBar } from './NavBar';

export enum SidebarMode {
  VERTICALS,
  SALES_HELP,
}

export interface IContentfulNavBar extends React.AllHTMLAttributes<HTMLElement> {
  mainContentRef?: React.RefObject<HTMLDivElement>;
  children?: never;
  sidebarMode?: SidebarMode;
}

export const ContentfulNavBar: React.FC<IContentfulNavBar> = ({ sidebarMode, ...props }) => {

  const { sidebarNavigation, sidebarHelpNavigation, headerNavigation, headerUtilNavigation } =
    useContentfulNavBar();

  const sidebarEntry = useMemo(() => {
    switch (sidebarMode) {
      case SidebarMode.SALES_HELP:
        return sidebarHelpNavigation;
      default:
        return sidebarNavigation;
    }
  }, [sidebarNavigation, sidebarHelpNavigation, sidebarMode]);

  const headerOverride = useNavBarContext().headerOverride;
  const headerUtilOverride = useNavBarContext().headerUtilOverride;
  const { override: sidebarOverride, setOpenability } = useSidebar();

  const sidebar = sidebarOverride || sidebarEntry;
  const sidebarItems = getField(sidebar, 'items');

  setOpenability(sidebarItems !== undefined && !!sidebarItems && sidebarItems.length > 0);

  return (
    <NavBar
      entry={headerOverride || headerNavigation}
      sidebarEntry={sidebar}
      utilEntry={headerUtilOverride || headerUtilNavigation}
      {...props}
    />
  );
};

// TODO - hook up with cart state to switch sidebarMode
